import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import { translate } from 'translations/i18n';

import { ChevronDown } from '../../shared/DesignSystem/Icons';

const IconWrapper = styled.div`
  margin-right: 6px;
`;

export const CompanySizeOptions = [
  {
    type: '1-3',
    value: 'ONE_TO_THREE',
  },
  {
    type: '4-10',
    value: 'FOUR_TO_TEN',
  },
  {
    type: '11-49',
    value: 'ELEVEN_TO_FOURTY_NINE',
  },
  {
    type: '50-99',
    value: 'FIFTY_TO_NINETY_NINE',
  },
  {
    type: '100-499',
    value: 'ONE_HUNDRED_TO_FOUR_HUNDRED_NINETY_NINE',
  },
  {
    type: '500-2499',
    value: 'FIVE_HUNDRED_TO_TWO_THOUSAND_FOUR_HUNDRED_NINETY_NINE',
  },
  {
    type: '2500+',
    value: 'TWO_THOUSAND_FIVE_HUNDRED_PLUS',
  },
];

const CompanySize = () => {
  const options = [
    {
      type: translate('companySize.select'),
      value: '',
      disabled: true,
    },
    ...CompanySizeOptions,
  ];

  return (
    <div className="form-field">
      <div
        className="input-wrap input-wrap--withicon"
        data-testid="signup__companySize"
      >
        <Field as="select" name="companySize" className="select-new-signup">
          {options.map((option) => (
            <option
              key={option.type}
              value={option.value}
              disabled={option.disabled}
              data-testid={`signup__companySize-${option.value}`}
            >
              {option.type}
            </option>
          ))}
        </Field>
        <label htmlFor="companySize">{translate('companySize.label')}</label>
        <IconWrapper>
          <ChevronDown size={20} color="#707B86" />
        </IconWrapper>
      </div>
    </div>
  );
};

export default CompanySize;
